import { BrowserCacheLocation, LogLevel, PublicClientApplication } from '@azure/msal-browser';
import { environment } from '../environments/environment';

// **MSAL Configuration**
export const msalConfig = {
  auth: {
    clientId: environment.azureAd.clientId, // 🔹 Replace with your Azure AD App Client ID
    authority: environment.azureAd.authority, // 🔹 Replace with your Tenant ID
    redirectUri: environment.azureAd.redirectUri, // 🔹 Must match the redirect URI in Azure Portal
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage, // Stores tokens in local storage
    storeAuthStateInCookie: true, // Recommended for cross-browser compatibility
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        if (!containsPii) {
          console.log(message);
        }
      },
      logLevel: LogLevel.Info,
    },
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

// **Login Request Configuration**
export const loginRequest = {
  scopes: [environment.azureAd.scope],// 🔹 Permissions requested from Azure AD
};